/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoRouteDelete($routeId: ID!) {
    PhoneNumberoRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`
